<div class="sort-button-container">
  <button
    appButton
    [color]="active() ? 'simple-primary' : 'hard-simple'"
    class="align-left"
    spacing="1-5"
    height="1"
    [name]="name()"
    [location]="location()"
    (click)="activeChanged.emit(!active())"
  >
    <ng-content></ng-content>
  </button>

  @if (active()) {
    @if (allowFlip()) {
      <button
        appButton
        name="flip-sorting"
        [location]="location()"
        (click)="flippedChanged.emit()"
        color="simple-primary"
        [iconButton]="true"
        class="inner-sorting-button"
        [class.flippped]="flipped()"
        height="1"
      >
        <app-svg src="/assets/icons/arrow-up.svg"></app-svg>
      </button>
    }
    @if (allowRandom()) {
      <button
        appButton
        name="random-sorting"
        [location]="location()"
        (click)="randomChanged.emit()"
        color="simple-primary"
        [iconButton]="true"
        class="inner-sorting-button"
        [class.flippped]="randomized()"
        height="1"
      >
        <app-svg src="/assets/icons/arrow-refresh.svg"></app-svg>
      </button>
    }
  }
</div>
